import Vue from 'vue';
import {Carousel, Slide} from 'vue-carousel';

export default function ($fragment) {
    $fragment.swFindWithSelf('[data-sw-carousel]').each(function () {
        const el = this;
        const $el = $(el);
        const peek = $el.attr('data-sw-carousel-peek');
        const slideCount = $el.find('slide').length - 1;
        new Vue({
            el: el,
            components: {
                Carousel,
                Slide
            },
            data: {
              currentSlide: 0,
              slideCount: slideCount,
              peek: peek
            },
            methods: {
              /**
               * Next button
               */
              next: function () {
                this.navigateTo = this.navigateTo + 1;
              },
              /**
               * Previous button
               *
               * Takes into account the selected slide not being the left most slide
               */
              prev: function () {
                if (this.navigateTo > this.slideCount - this.slidesPerPage) {
                  this.navigateTo = this.slideCount - this.slidesPerPage;
                } else {
                  this.navigateTo = this.navigateTo - 1;
                }
              }
            },
            computed: {
              /**
               * Gets this current slide
               * Sets the current slide but keeps it within the bounds of 0 and the count of slides
               */
              navigateTo: {
                get: function () {
                  return this.currentSlide;
                },
                set: function (slideNum) {
                  if (slideNum < 0) {
                    this.currentSlide = this.slideCount - 1;
                  } else if (slideNum > (this.slideCount+ 1 - this.slidesPerPage)) {
                    this.currentSlide = 0;
                  } else {
                    this.currentSlide = slideNum;
                  }
                }
              },
              /**
               * Gets the current number of slides showing on the page from the component
               * This can change because of custom per page option
               */
              slidesPerPage: function () {
                return this.$refs.carousel ? this.$refs.carousel.currentPerPage : 0;
              },
              /**
               * The currently selected index directly from the component
               */
              currentIndex: {
                cache: false,
                get() {
                  return this.$refs.carousel ? this.$refs.carousel.currentPage : 0;
                }
              },
              /**
               * Here we can add styles to the slides
               * Right now it only adds some padding and margin to add peeking if the option is set up
               */
              slideStyle: {
                cache: false,
                get() {
                  // To explain what is going on here:
                  // Pulling the slides to the left will cause the negative margin to stack with each slide
                  // So with a margin of -10, the 5th slide will have a margin of 5 * -10 = -50
                  // To fix this we can decrease the margin so that the peek size causing each slide before this to pull less
                  // To do this, decrease the peek by the peek divided by the slide count for each frame before this

                  let peek = this.peek;
                  let step = peek / this.slideCount;
                  peek -= this.currentIndex * step;

                  return 'padding-right:' + peek + 'px; margin-left: ' + -peek + 'px';
                }
              }
            }
        });
    });
};
